export default __webpack_public_path__ + "static/1-1eb2238ca8cb8bde4329096796dc0cb4.gif";